/* @flow */
import React from 'react';
import Timestamp from 'components/Timestamp.jsx';

import './styles/MessageListTimeItem.scss';

class MessageListTimeItem extends React.PureComponent {
  static propTypes = {
    date: React.PropTypes.instanceOf(Date).isRequired,
  };

  render() {
    return (
      <li className="MessageListTimeItem">
        <Timestamp className="MessageListTimeItem-date" date={this.props.date} format="long" />
      </li>
    );
  }
}

export default MessageListTimeItem;



// WEBPACK FOOTER //
// ./src/chat/components/MessageListTimeItem.jsx